import { useRef } from "react";
import { Toast } from "primereact/toast";

interface ShowParams {
  summary?: string;
  detail?: string;
  life?: number;
}

export const useToast = () => {
  const toastRef = useRef<Toast>(null);

  const showSuccess = (summary = "Успешно", detail = "Данные сохранены") => {
    toastRef.current?.show({
      severity: "success",
      summary,
      detail,
      life: 3000,
    });
  };

  const showError = (
    summary = "Ошибка",
    detail = "Изменения не сохранены. Пожалуйста, попробуйте позже"
  ) => {
    toastRef.current?.show({
      severity: "error",
      summary,
      detail,
      life: 3000,
    });
  };

  const showWarning = (
    summary = "Предупреждение",
    detail = "Пожалуйста, заполните все необходимые поля ввода"
  ) => {
    toastRef.current?.show({
      severity: "warn",
      summary,
      detail,
      life: 3000,
    });
  };

  const showDataIsLoading = (
    summary = "Данные загружаются...",
    detail = "",
    lifeTime = 1000
  ) => {
    toastRef.current?.show({
      severity: "info",
      summary,
      detail,
      life: lifeTime,
    });
  };

  return {
    toastRef,
    showSuccess,
    showError,
    showWarning,
    showDataIsLoading,
  };
};
